import GoogleSignInPlugin from 'vue3-google-signin'

export default defineNuxtPlugin((nuxtApp) => {
  const { googleLoginClientId } = useRuntimeConfig().public

  if (!googleLoginClientId) {
    console.error('GoogleSignInPlugin: googleLoginClientId is not set.')
  } else {
    nuxtApp.vueApp.use(GoogleSignInPlugin, { clientId: googleLoginClientId })
  }
})
